import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import UnstyledButton from 'components/unstyled-button';
import { theme } from 'styles/configure-theme';

import { DropdownArrow } from './dropdown-arrow';

const DropdownContainer = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: {
    base: '$2',
    md: '$3',
  },
});

const dropdownArrowSize = {
  mobile: {
    height: 10,
    width: 5.71,
  },
  desktop: {
    height: 14,
    width: 8,
  },
};

const dropdownArrowOrientation = {
  initialAngleDeg: 90,
  finalAngleDeg: -90,
};

export const DropdownIndicator: React.FC<React.PropsWithChildren<{
  isOpen: boolean;
  isDisabled?: boolean;
}>> = ({ isOpen, isDisabled = false }) => (
  <DropdownContainer>
    <DropdownArrow
      open={isOpen || false}
      disabled={isDisabled || false}
      size={dropdownArrowSize}
      orientation={dropdownArrowOrientation}
    />
  </DropdownContainer>
);

const ClearButton = UnstyledButton.withConfig({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 0,
  padding: {
    base: '$2',
    md: '$3',
  },
  paddingRight: {
    md: '$2',
  },
});

const Clear = Icon.withConfig({
  size: { base: '$4', md: '$5' },
});

export const ClearIndicator: React.FC<React.PropsWithChildren<{
  isDisabled?: boolean;
  onPress: () => void;
}>> = ({ isDisabled = false, onPress }) => {
  const { formatMessage } = useIntl();
  return (
    <ClearButton accessibilityLabel={formatMessage({ id: 'clearFilter' })} onPress={onPress}>
      <Clear
        variant="cancel"
        color={isDisabled ? theme.token('icon-disabled') : theme.token('icon-default')}
      />
    </ClearButton>
  );
};

export const IndicatorSeparator = Box.withConfig({
  width: '1px',
  alignSelf: 'stretch',
  marginX: 0,
  marginY: '$1',
  backgroundColor: '__legacyToken.border-color-default',
});
